module.exports = __webpack_public_path__ + "img/steam.848d7603.png";